import Controller from '../abstracts/Controller';
import 'scss-templates/t-lookbook.scss';

export default class LookbookController  extends Controller {
  static get COMPONENTS() {
    return [
        'AddToCartComponent',
        'LookbookModalComponent',
        'SizeSelectorComponent'
    ];
  }
}
